import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { overrideSmsInput, changeTo, toggleMessageMenu } from 'actions/inbox'

const RetrySend = ({
  to,
  text,
  media_url,
  overrideSmsInput,
  changeTo,
  toggleMessageMenu,
}) => {
  const retry = () => {
    overrideSmsInput(text).then(() => {
      changeTo('text', to)
      toggleMessageMenu(true)
    })
  }

  return (
    <span
      onClick={() => retry()}
      style={{ textDecoration: 'underline', cursor: 'pointer' }}
    >
      Click to retry
    </span>
  )
}

export default connect(
  state => ({

  }),
  dispatch => bindActionCreators({ overrideSmsInput, changeTo, toggleMessageMenu }, dispatch),
)(RetrySend)
